import React, { useContext, useEffect, useState } from 'react'
import { approveUserRequest, getUsers, getUsersForSettings } from '../../../services/private/plus.leads.service';
import { ReactComponent as PlusIcon } from '../../../assets/plus_icon/plus.svg';
import InviteUserModal from './Modal/InviteUserModal';
import Consumer from '../../../helpers/context';
import { ReactComponent as WhatsappIcon } from '../../../assets/plus_icon/whats_app.svg';
import TooltipText from '../../../components/Tooltip';
import { ReactComponent as ThreedotsIcon } from '../../../assets/icons/threedots.svg';
import { toast } from 'react-toastify';
import Searchbox from '../../../components/InputGroup/Searchbox';


const Users = () => {
    const [users, setUsers] = useState([]);
    const [showInviteUserModal, setShowInviteUserModal] = useState(false);
    const [selectedUser, setSelectedUser] = useState({})
    const [searchText, setSearchText] = useState('');

    const { userProfile } = useContext(Consumer);

    const getCompanyUsers = async () => {
        const res = await getUsers();
        if (res.data.status === 200) {
            setUsers([...res.data.data.users, ...res.data.data.requests]);
        }
    }

    useEffect(() => {
        getCompanyUsers();
    }, []);

    const handleChangeStatus = async (uuid, status) => {
        const res = await approveUserRequest({ uuid, status });
        if (res.data.status === 200) {
            console.log(res.data.data);
            toast.success(res.data.message);
            getCompanyUsers();
        }
    }
    return (
        <div className="users w-100 h-full flex flex-col">
            <div className="settings-title">
                <div className="row d-flex d-flex flex-md-fill flex-wrap">
                    <div className="col-md-7 col-6 d-flex flex-md-fill flex-column">
                        <h1 className="fz24 mb-16 black fw-po-medium">Users</h1>
                    </div>
                    <div className="col-md-5 col-6 d-flex justify-content-end align-items-md-end aling-items-center d-flex flex-md-fill">
                        {/* Search Box */}
    <div className="w-full sm:w-auto">
        <Searchbox 
            value={searchText} 
            onChange={(e) => setSearchText(e.target.value)} 
            handelClear={() => setSearchText('')} 
            placeholder="Search for Site visits" 
            classname="mr-0" 
        />
    </div>
                       <div className="pl-2">
                            {userProfile.is_owner && <button className='pr-btn flex items-center' onClick={() => setShowInviteUserModal(true)}>
                                <PlusIcon className='fill-white' />
                                Add User
                            </button>}
                        </div>
                        <div className='!ml-2'>
                            <TooltipText title={'Invite User'}>
                                <a className='' target='_blank'
                                    onClick={() => {
                                        const message = `Welcome to Propacity!

                                    You have been successfully added to our team by ${userProfile?.company_name}. Your company code is ${userProfile.company_code}
                                    
                                    Use following link to create account:
                                    Web: https://plus.propacity.in/singup_page_url?company_code=${userProfile.company_code}
                                    Android: $android_link_with_company_code
                                    IOS: $IOS_link_with_company_code
                                    
                                    Best regards,
                                    Team Propacity ⁠`;
                                        window.open(`https://api.whatsapp.com/send?text=${(message)}`)
                                    }}
                                >
                                    <WhatsappIcon className='w-8 h-8' />
                                </a>
                            </TooltipText>
                        </div>
                    </div>
                </div>
            </div>
            <div className="user-table ml-24 mt-24">
                <div className="def-table pr-24">
                    <table className='table'>
                        <thead>
                            <tr>
                                <th>S.No.</th>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Mobile No.</th>
                                {/* <th>Status</th> */}
                                <th>Role </th>
                                {/* <th>Modified Date</th> */}
                                <th>Status</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                users?.length > 0 && users.map((user, index) => (
                                    <tr key={`${user.role_uuid}_${index}`}>
                                        <td>{index + 1}</td>
                                        <td className="text-capitalize">{user?.name || '-'}</td>
                                        <td>{user?.email || '-'}</td>
                                        <td>{user?.mobile || '-'}</td>
                                        <td className="">
                                            {/* {user?.role_name || 'Employee'} */}
                                            {user.role_name === 'Super Admin' ? 'Owner' : 'Employee'}
                                        </td>
                                        {/* <td>{'-'}</td> */}
                                        <td>{user?.is_active ? 'Active' : 'Inactive'}</td>
                                        <td>
                                            <div className="dropdown view-more d-flex">
                                                <button className="bg-tr border-0 px-0" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                    <ThreedotsIcon />
                                                </button>
                                                <div className="dropdown-menu w-auto dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                                                    {/* <div className="head-itme pb-2 text-black700 text-xs font-medium m-0">Add <span></span></div> */}
                                                    {user.status === 'pending' && <a
                                                        className="dropdown-item mb-8 text-sm"
                                                        onClick={() => {
                                                            handleChangeStatus(user.uuid, 'approve')
                                                        }}
                                                    > Accept </a>}
                                                    {user.status === 'pending' && <a
                                                        className="dropdown-item mb-8 text-sm"
                                                        onClick={() => {
                                                            handleChangeStatus(user.uuid, 'reject')
                                                        }}
                                                    > Reject </a>}
                                                    {userProfile?.role_name === 'Super Admin' && <a
                                                        className="dropdown-item mb-8 text-sm"
                                                        onClick={() => {
                                                            setSelectedUser(user);
                                                            setShowInviteUserModal(true);
                                                        }}
                                                    > Edit </a>}
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
            </div>
            {showInviteUserModal && <InviteUserModal
                show={showInviteUserModal}
                closeModal={() => {
                    setShowInviteUserModal(false)
                    setSelectedUser({})
                }}
                getUsers={getCompanyUsers}
                selectedUser={selectedUser} />}
        </div>
    )
}

export default Users;